export default __webpack_public_path__ + "static/media/verdinhosUm.0d42bfe0.png";